<template>
     <section class="container d-none d-md-block">

            <div class="row">

                <div class="col-md-12">

                    <div class="accreditations">

                        <h2>The Health and Safety Group memberships and approved centres:</h2>

                        <div class="d-flex flex-row justify-content-between align-center">

                            <img class="img-fluid" :src="s3+'/images/rospa-v1.jpg'" alt="ROSPA">
                            <img class="img-fluid cpd-img" :src="s3+'/images/CPD-Provider-Logo-Centre.png'" alt="Accredited-cpd centre">
                            <img class="img-fluid" :src="s3+'/images/MHFA-LOGO.jpg'" alt="MFHA">
                            <img class="img-fluid" :src="s3+'/images/back-care.png'" alt="Back Care">

                        </div>

                    </div>

                    <section class="row hsg d-none d-md-block mt-4 subsidiaryOwnerSection">
                        <div class="offset-md-2 col-md-8 offset-md-2 text-center">
                            <h2 class="mb-4">My Healthy Staff is a wholly owned subsidiary of</h2>
                            <img :src="s3+'/images/hsg-logo-v1.png'" alt="" class="footer-logo">
                        </div>
                    </section>

                </div>

            </div>

        </section> 
</template>

<script>
export default {
    name: 'subsidiary',
    data(){
    return {
       s3: process.env.VUE_APP_CDN_IMAGE_URL
    }
  },
}
</script>

<style lang="scss" scoped>
.accreditations{
    text-align: center;
    padding-top: 16px;

    h2{
      font-weight: 600;
      font-size: 17px;
      color: #1d1d1b;
      margin-bottom: 32px;
    }
    img{
        height: 70px;
        width: auto;
        margin-bottom: 0;
    }
    .cpd-img {
        height: 100px !important;
    }
  }

.subsidiaryOwnerSection{
    border-top: thin solid #828282;

    h2{
        color: #1d1d1b;
    }

    .footer-logo {
    max-width: 40%;
    }
}
</style>
